/**
 * Deshabilita validación jQuery para #contact_form
 * Previene conflicto con SweetAlert2 y reCAPTCHA v3 en formulario PQRS
 * IMPORTANTE: Deshabilita el módulo 'security' (reCAPTCHA v2 del plugin) globalmente
 * @author carlos rodriguez
 * @since 2025
 */

// Ejecutar INMEDIATAMENTE (antes de que jquery.form-validator se inicialice)
(function() {
    'use strict';
    
    // Deshabilitar el módulo security ANTES de que cualquier $.validate() se ejecute
    $(document).ready(function() {
        // Silenciar advertencias del plugin
        if ($.formUtils) {
            $.formUtils.warn = function() {};
        }
        
        // Remover validación de #contact_form (PQRS)
        if (typeof $.validate !== 'undefined') {
            $('#contact_form').off('submit.jqueryvalidation');
            $('#contact_form').removeData('validator');
            
            //console.log('✅ Validación jQuery deshabilitada para #contact_form');
        }
        
        // Desactivar módulo security para todos los demás formularios
        // Esto previene conflicto con reCAPTCHA v3 manual
        if ($.formUtils && $.formUtils.addValidator) {
            // Override del validador security (reCAPTCHA v2)
            $.formUtils.addValidator({
                name: 'recaptcha',
                validatorFunction: function() {
                    return true; // Siempre válido (usamos reCAPTCHA v3 custom)
                },
                errorMessage: '',
                errorMessageKey: ''
            });
            
            //console.log('✅ Módulo security (reCAPTCHA v2) del plugin deshabilitado');
        }
    });
})();
